import cookieUtils from "cookie";

const defaultCookieOptions = { maxAge: 60 * 60 * 24 * 365 * 1, path: "/research" };
const invalidateOptions = { maxAge: 0, path: "/" };

export const getCookie = (name) => {
  const cookies = cookieUtils.parse(document.cookie);
  return cookies && cookies[name] ? cookies[name] : null;
};

export const setCookie = (name, value, options = defaultCookieOptions) => {
  document.cookie = cookieUtils.serialize(name, value, options);
  document.cookie = cookieUtils.serialize(name, value, invalidateOptions); // invalidate cookies on root path
};
